var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lib-tippy',{staticClass:"cursor-pointer",attrs:{"delay":[50, 0],"placement":_vm.placement,"animation":"shift-toward","arrow":""},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)},[_vm._v(" "),(_vm.$slots.content)?_c('div',[_vm._t("content")],2):_c('div',[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }